import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

import HeaderTexts from "../../common/HeaderTexts";
import { showNotification } from '../../../../common/notifications/notifications';
import { customerCancelJob } from '../../../currentJob/service';
import { removeCurrentJob } from '../../../../storage';
import useCustomNavigate from '../../../../common/hooks/useCustomNavigate';

const FindingTemplate = ({ title, subTitle, job_id = null }) => {
    const { navigateToCustom } = useCustomNavigate();

    const handleJobCancellation = useCallback(
        async () => {
            showNotification({
                notificationType: "CANCEL_JOB",
                preConfirm: async () => await customerCancelJob(job_id),
                isConfirmed: (result) => {
                    if (!result.isConfirmed || result.value?.status !== "Success") return;

                    removeCurrentJob();
                    navigateToCustom("/home");
                    return;
                },
            });
        },
        [job_id, navigateToCustom]
    );
    
    return (
        <div className="mx-3 d-flex flex-column h-100">
            <HeaderTexts
                title="Finding your tradesperson"
                subTitle=""
            />

            {/* Vertical center content */}
            <div className="d-flex flex-column justify-content-center flex-grow-1">
                <h5 className="mb-2 text-center">{title}</h5>

                <p className="mb-0 text-center">
                    {subTitle}
                </p>

                <Box sx={{ width: '100%', mt: 4 }}>
                    <LinearProgress
                        aria-label="Loading…"
                        color="success"
                    />
                </Box>

                {job_id && (
                    <button className="btn btn-link text-secondary mt-5" type="button" onClick={handleJobCancellation}>
                        Cancel request
                    </button>
                )}
            </div>
        </div>
    );
};

export default FindingTemplate;